

'use strict';

var jquery = require('jquery');


var RouletteCube = function($elem, data, onClickCallback) {

    this.$baseElem = $elem;
    this.data = data;
    this.onClickCallback = onClickCallback;

    this.sides = [
        {
            name: 'front',
            angle: 0,
            $elem: this.$baseElem.find('[data-side="front"]')
        },

        {
            name: 'back',
            angle: 180,
            $elem: this.$baseElem.find('[data-side="back"]')
        },

        {
            name: 'top',
            angle: 270,
            $elem: this.$baseElem.find('[data-side="top"]')
        },

        {
            name: 'bottom',
            angle: 90,
            $elem: this.$baseElem.find('[data-side="bottom"]')
        }
    ];

    this.activeSide = null;
    this.currentRotation = 0;
    this.rotationIterations = 0;

    this.iterations = {
        max: 8,
        min: 5
    };

    // transition duration

    this.init();

    this.configureEvents();

};


RouletteCube.prototype = {
    constructor: RouletteCube,

    mapRange: function(value, low1, high1, low2, high2) {
        return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
    },

    getRandomData: function() {
        var indexList = [];
        var index;

        while (indexList.length < this.sides.length) {
            index = Math.round( Math.random() * this.data.length - 1 );

            if ( indexList.indexOf(index) === -1 ) {
                indexList.push(index);
            }
        }

        return indexList;
    },


    setNames: function() {
        var indexList = this.getRandomData();
        var activeSide = this.activeSide;
        var dataList = this.data;
        // console.log('indexList', indexList);

        this.sides.forEach(function(item, index) {
            if (index === activeSide) {
                return;
            }

            item.$elem.find('[data-text]').text( dataList[ indexList[index] ] );
        });

        // console.log('activeSide', activeSide);
    },

    randomSpin: function(noTransition) {
        this.setNames();

        var sideIndex = null;
        var sides = this.sides;
        
        // randomly pick a side
        while ( sideIndex === null || sideIndex === this.activeSide ) {
            sideIndex = Math.round( Math.random() * sides.length - 1 );
            sideIndex = Math.max( 0, Math.min(sideIndex, sides.length - 1) );
        }

        this.activeSide = sideIndex;

        // console.log('sideIndex', sideIndex);
        // console.log('this.sides[sideIndex].name', this.sides[sideIndex].name);

        // calculate iterations
        var iterations = this.mapRange( Math.random(), 0, 1, this.iterations.min, this.iterations.max - 1 );
        iterations = Math.round(iterations);

        // console.log('iterations', iterations);

        // count up iterations
        this.rotationIterations += iterations;

        var targetAngle = this.sides[sideIndex].angle;
        var finalRotation = (this.rotationIterations * 360) + targetAngle;

        // console.log('targetAngle', targetAngle);
        // console.log('finalRotation', finalRotation);

        // final rotation check
        // if higher than certain value
        // set it back to 0 and set the active side to front

        this.currentRotation = finalRotation;

        if (noTransition) {
            var $rotateContainer = this.$rotateContainer;
            $rotateContainer.css('transition-duration', '0ms');

            window.setTimeout(function() {
                $rotateContainer.css('transition-duration', '');
            }, 50);
        }

        this.$rotateContainer.css('transform', 'rotateX(' + finalRotation + 'deg)');
    },


    init: function() {
        // console.log('init cube');
        this.$rotateContainer = this.$baseElem.find('[data-rotate-container]');
        this.randomSpin(true);
    },

    onBaseElemClick: function() {
        // debugger;
        this.randomSpin();

        if (this.onClickCallback) {
            this.onClickCallback();
        }
    },

    configureEvents: function() {
        this.$baseElem.on( 'click', this.onBaseElemClick.bind(this) );
    }
};


module.exports = RouletteCube;




/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/src/name-roulette/nameRouletteCube.js
 ** module id = 7
 ** module chunks = 0
 **/